import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MovieCard from '@/components/feature/MovieCard';
import ArticleCard from '@/components/feature/ArticleCard';
import { movies } from '@/mocks/movies';
import { categories } from '@/mocks/movies';
import { articles } from '@/mocks/articles';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const featuredMovies = movies.slice(0, 8);
  const latestMovies = movies.slice(0, 12);
  const featuredCategories = categories.slice(0, 6);
  const latestArticles = articles.slice(0, 3);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '蘑菇影视',
    url: 'https://mogutv.com/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://mogutv.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '蘑菇影视 - 高清超清免费在线观看',
    description: '蘑菇影视聚集高清、超清、4K、蓝光画质影视资源，免费在线观看，无广告干扰，播放流畅不缓冲。',
    url: 'https://mogutv.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '蘑菇影视',
      url: 'https://mogutv.com/',
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webpageSchema)}
      </script>

      <Navbar />

      <main>
        <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20atmosphere%20with%20floating%20golden%20particles%20and%20soft%20glowing%20light%20streaks%2C%20abstract%20geometric%20film%20reel%20elements%2C%20deep%20charcoal%20black%20background%20with%20warm%20amber%20and%20coral%20accents%2C%20luxurious%20premium%20entertainment%20ambience%2C%20elegant%20gradient%20lighting%2C%20no%20text%20or%20lettering%2C%20atmospheric%20and%20mysterious%20cinematic%20mood&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
            alt="蘑菇影视 - 高清影视在线观看"
            title="蘑菇影视 - 高清超清免费在线观看"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
            <div className="w-full max-w-3xl">
              <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
                高清超清 免费在线观看
              </h1>
              <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
                4K蓝光画质 · 无广告干扰 · 播放流畅不缓冲 · 享受极致观影体验
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/dongzuo"
                  className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 transform"
                >
                  <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
                    <i className="ri-play-circle-line"></i>
                  </div>
                  开始观影
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 rounded-lg bg-white/10 backdrop-blur-sm text-white font-medium text-sm border border-white/20 hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </div>
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
            <div className="w-8 h-8 flex items-center justify-center animate-bounce">
              <i className="ri-arrow-down-s-line text-white/60 text-xl"></i>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900">
                  精选推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">编辑精心挑选的高分影视作品</p>
              </div>
              <Link
                to="/category/dongzuo"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
              >
                查看全部
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {featuredMovies.map((movie) => (
                <MovieCard key={movie.id} {...movie} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900">
                影视分类
              </h2>
              <p className="text-sm text-foreground-500 mt-1">海量资源 · 精准分类 · 快速找到你想看的</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {featuredCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="bg-background-50 rounded-lg p-4 md:p-5 text-center border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group hover:-translate-y-1"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-3 rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-400 line-clamp-1 hidden sm:block">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900">
                  最新上线
                </h2>
                <p className="text-sm text-foreground-500 mt-1">最新最热的影视内容，持续更新中</p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {latestMovies.map((movie) => (
                <MovieCard key={movie.id} {...movie} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900">
                  影视资讯
                </h2>
                <p className="text-sm text-foreground-500 mt-1">最新影评、推荐和行业动态</p>
              </div>
            </div>
            <div className="flex flex-col gap-4">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
            <div className="text-center mt-8">
              <Link
                to="/article/1"
                className="inline-flex items-center gap-1 px-6 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-foreground-600 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                查看更多文章
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
              <div className="absolute inset-0 bg-black/10"></div>
              <div className="relative z-10">
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">
                  现在就开始你的观影之旅
                </h2>
                <p className="text-background-50/80 text-sm md:text-base mb-6 max-w-lg mx-auto">
                  海量高清影视资源，无广告、不缓冲，随时随地畅享极致观影体验
                </p>
                <Link
                  to="/category/dianshiju"
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-lg bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 transform"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-play-circle-fill"></i>
                  </div>
                  免费观影
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}